import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { TipComponent } from './tip.component';

@NgModule({
    imports: [
        CommonModule,
        SvgIconModule,
    ],
    exports: [ TipComponent ],
    declarations: [ TipComponent ],
})
export class TipModule {}
